import { render, staticRenderFns } from "./AttachFileDialog.vue?vue&type=template&id=68828d94&"
import script from "./AttachFileDialog.vue?vue&type=script&lang=js&"
export * from "./AttachFileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports